import { useAuth } from './AuthProvider'
import { PermissionMapper } from '../components/PermissionMapper/permissionMapper'
import { ACTIONS } from '../components/PermissionMapper/constants'
import { URL_UNAUTHORIZED } from '../constants'
import React, { createContext, useContext, useMemo } from 'react'

export interface PermissionProviderProps {
  ACTIONS: Record<string, string>
  hasAction: (action: ACTIONS) => boolean
  hasNavAction: (action: ACTIONS) => boolean
  hasDataFilterAction: (action: ACTIONS) => boolean
  getLandingUrl: (baseUrl?: string) => string
}

const initContext = {
  ACTIONS,
  hasAction: () => false,
  hasNavAction: () => false,
  hasDataFilterAction: () => false,
  getLandingUrl: () => URL_UNAUTHORIZED
}
const PermissionContext = createContext<PermissionProviderProps>(initContext)

function PermissionProvider({ children }) {
  const { userDetails } = useAuth()

  // Create permission mapper with user permissions
  const permissionMapper = useMemo(() => {
    const { permissions, scope, isViewOnly } = userDetails?.roles?.[0] || {}
    return new PermissionMapper(permissions, scope, isViewOnly)
  }, [userDetails])

  // Context value
  const data = {
    ACTIONS,
    hasAction: (action: ACTIONS) => permissionMapper.hasAction(action),
    hasNavAction: (action: ACTIONS) => permissionMapper.hasNavAction(action),
    hasDataFilterAction: (action: ACTIONS) => permissionMapper.hasDataFilterAction(action),
    getLandingUrl: (baseUrl) => permissionMapper.getLandingUrl(baseUrl)
  }

  return <PermissionContext.Provider value={data}>{children}</PermissionContext.Provider>
}

export default PermissionProvider

export function usePermission() {
  return useContext(PermissionContext)
}
